import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Hero from "./components/Hero";
import GettingStarted from "./components/GettingStarted";
import ProductShowcase from "./components/ProductShowcase";
import Pricing from "./components/Pricing";
import ContactOrder from "./components/ContactOrder";
import Footer from "./components/Footer";

function App() {
  const Home = () => (
    <>
      <Hero />
      <GettingStarted />
      <ProductShowcase />
      <Pricing />
      <ContactOrder />
      <Footer />
    </>
  );

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
